import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import i18n from '../../i18n';
import AuthService from '../../services/AuthService';
import InternalUserService from '../../services/InternalUserService';
import I18nUtils from '../utils/I18nUtils';
import { Card } from 'primereact/card';
import { BreadCrumb } from 'primereact/breadcrumb';
import SessionTimer from '../../containers/SessionTimer';

class HeaderComponent extends Component {
    constructor(props) {
        super(props);
        this.authService = new AuthService();
        this.internalUserService = new InternalUserService();

    }

    componentDidMount() {
        if (!sessionStorage.getItem('i18nextLng')) {
            this.authService.refresh().then((res) => {
                sessionStorage.setItem('i18nextLng', res.language);
                i18n.changeLanguage(res.language);
            });
        }        
    }

    componentWillUnmount() {
        i18n.changeLanguage();
    }

    render() {
        const {t, renderContent} = this.props;
        const supportedLanguages = I18nUtils.getSupportedLanguages(2);
        const languages = [];
        supportedLanguages.forEach((l) => {
            languages.push({value: l, label: t(`header.${l}`)});
        });
        //const items = [{ label: 'Projekty' }, { label: 'Projekt' },];
        //const home = { icon: 'pi pi-home', url: 'https://primereact.org' }
        const topPanel = renderContent ? renderContent() : null;
        const topPanelVisible = topPanel !== undefined && topPanel !== null;

        return (            
            <React.Fragment>
                {this.authService.loggedIn() ? (
                    <header className='container-fluid' id='main-header-container'> 

                        <div className="header-container">
                            <span id='profile-button' className="icon configuration" title="Konfiguracja" onClick={() => {
                                window.location.href = '/#/profile'
                            }}>
                                <i className="mdi mdi-account-cog" />
                            </span>
                            <span id='logout-button' className="icon logout" title="Wyloguj" onClick={this.props.logout}>
                                <i className="mdi mdi-logout" />
                            </span>
                            <SessionTimer />
                    
                        </div>
                    
                        
                        <div className='header-content'>
                            
                            {this.props.label && topPanelVisible ? (                                
                                <Card style={{                                            
                                    marginBottom: '20px',
                                    position: 'relative',
                                    padding: '0', 
                                    minHeight: '100px',
                                    width: '100%'                                         
                                    }}
                                >
                                    <div className='top-panel-container' id="top-panel-container">
                                        {renderContent()}
                                    </div>                                    
                                    {/* <BreadCrumb model={items} home={home} /> */}
                                </Card>                               
                            ) : this.props.label ? (
                                <>
                                    <span className='header-welcome header-welcome-label'>{t(this.props.label)}</span>                                    
                                </>
                            ) : (
                                <span className='header-welcome'>
                                    {t('header.welcome')},
                                    <b>
                                        {`${
                                            this.authService.getProfile().name && this.authService.getProfile().name.trim().length > 0
                                                ? ' ' + this.authService.getProfile().name
                                                : ''
                                        } `}
                                    </b>
                                </span>
                            )}
                        </div>
                    </header>
                ) : null}
            </React.Fragment>
        );
    }
}

export default withTranslation()(HeaderComponent);
